module.exports = __webpack_public_path__ + "img/login-bj1.69bbee67.gif";